import React, { Component } from 'react';
import './toolStrip.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
//import { layer } from '@fortawesome/fontawesome-svg-core';
//import axios from '../../../Axios/axios';



class ToolStrip extends Component {
    constructor(props) {
      super(props);
      // PROPS
      /* --config = [{name:"Add",isEnable:true/false, show:"show/hide", icon:"plus"}]
          // List of object describing button. 
            // name : name of the button
            // isEnable : make it clickable or not
            // show : visible or not (removing the item from the list do the trick too)
            // icon : a previously integrated fontawesome icon

          --object // RELATED OBJECT TO INTERRACT
          --OnClickElement.bind(this,item,relatedObject)  // Callback method
            //this : context
            //item : object button clicked
            //relatedObject : object to return in the callback
          --preventMultipleClick //delay in ms before being able to click again
      */  
      this.state = {
        pendingRequest:false //display spinner if you want to prevent multiple clicks
      };
      this.timer=null;

  }


  // INNER METHOD
  componentWillUnmount = () =>{
    clearTimeout(this.timer);
  }
  
  OnClickElement = (item) =>{
    if(this.props.preventMultipleClick !== null && this.props.preventMultipleClick >=0){
      this.setState({pendingRequest:true});
      this.props.OnClickElement(item,this.props.object);
      // waiting as defined
      this.timer = setTimeout(
        function() {
          this.setState({pendingRequest:false});
        }
        .bind(this),
        this.props.preventMultipleClick
      );
    }else{
      this.props.OnClickElement(this,item,this.props.object)
    }
  }


  // BUILDING METHOD
  createTools = () =>{
    var tools=null;
    tools = this.props.config.map((item,i)=>{
      return (
        <div key={i} onClick={this.OnClickElement.bind(this,item)} className={"item enable-"+item.isEnable+" "+item.show} title={item.name}>
          <FontAwesomeIcon icon={item.icon}/>
        </div>
      )
    });
    

    return tools;
  }
  
  // ---------------------RENDER --------------------- 
  render() {
    var Tools = this.createTools();

      return (
          <div className="toolStrip-wrapper" >
            {Tools}
            <div className={this.state.pendingRequest?"ts_loader show":"ts_loader hide"}><FontAwesomeIcon icon="spinner"/></div>
          </div>
      );
  }
}
  
const mapStateToProps = (state) => {    
  return {  
    sessionId: state.apiReducer.sessionId,
  } 
}
const mapDispatchToProps = (dispatch) => {
  return {
  } 
} 

export default connect(mapStateToProps, mapDispatchToProps)(ToolStrip);
  